<template>
    <div>
        <div style="margin-bottom: 10px;position: relative;width: 100%;height: 4vh;">
            <el-button type="primary" icon="el-icon-edit" style="position: absolute;right: 0;top: 0;"
                @click="submitUpload" v-loading.fullscreen.lock="fullscreenLoading"
                    element-loading-text="正在保存中...">保存</el-button>
        </div>
        <el-row>
            <el-col>
                <div class="grid-content bg-purple">
                    <el-select style="width: 100%;display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;" v-model="value" filterable remote value-key="Id"
                        @focus="setOptionWidth"
                        placeholder="请输入关键词选择考核细项" :remote-method="remoteMethod" :loading="loading"
                        @change="handleRemoteMethodChange($event)"   >
                        <el-option v-for="(item, index) in options" :key="index"  :style="{width:selectOptionWidth}"
                            :label="item.ReviewPoints + ' || ' + item.ReviewMethod" :value="item" :title="item.ReviewPoints + ' || ' + item.ReviewMethod">
                        </el-option>
                    </el-select>
                </div>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
            <el-col>
                <el-upload ref="uploadAll" class="upload-demo" drag :limit="5" action="#" multiple :auto-upload="false"
                    :file-list="fileList" :on-preview="handlePreview" :on-change="handleChange" :on-remove="handleRemove"
                    :before-remove="beforeRemove" :http-request="uploadFile">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
            <el-table :data="tableData" border style="width:100%">
                <el-table-column prop="StIndex" width="100" label="标准序号" align="center"
                    :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="ReviewPoints" width="180" label="评审要点" align="center"
                    :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="ReviewMethod" width="180" label="评审方法" align="center"
                    :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button size="small" type="text" @click="remove(scope.$index)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>

<script>
import {
    getSelectDetailItem, postUploadAllSave
} from "../../api/EvaluationAgency/EvaluationAgency";
export default {
    data() {
        return {
            selectOptionWidth:0,
            fullscreenLoading:false,
            filedata: new FormData(),
            fileList: [],
            tableData: [],
            options: [],
            value: "",
            list: [],
            loading: false,
            states: []
        }
    },
    watch:{
        fileList: {
        handler(newVal) {
            console.log(newVal.length, "newVal.length");
            if (newVal.length) {
            this.$refs["dataForm"].clearValidate(["fileList"]);
            }
        },
        deep: true
        }
    },
    mounted() {
        this.remoteMethod('');
    },
    methods: {
        //上传之前事件
        handleChange(file) {
            console.log(file);
            var sz=["doc","docx","txt","pdf","xlsx","xls"];
            var name = (file.name.substring(file.name.lastIndexOf('.') + 1)).toLowerCase();
            if (!sz.includes(name)) {
                this.$message({
                message: '只能上传的文件格式为doc、docx、txt、pdf、xlsx、xls',
                type: 'warning'
                });
                this.$refs.uploadAll.clearFiles(); 
                return;
            }
        },
        // 上传到后台
        async submitUpload() {
            console.log(this.$refs.uploadAll.uploadFiles);
            if (this.tableData.length == 0) {
                this.$message({
                    message: '请选择考核细项!',
                    type: 'warning'
                });
                return
            }
            if (this.$refs.uploadAll.uploadFiles.length > 0) {
                let tempData = this.filedata;
                this.filedata = new FormData();//  用FormData存放上传文件
                this.$refs.uploadAll.submit();// 会循环调用uploadFile方法，多个文件调用多次
                var sz = this.tableData.map(i=>i.Id);
                this.filedata.append("DetailItemId", sz.join(","));
                this.fullscreenLoading=true;
                //uploadBootLogo是上传接口
                await postUploadAllSave(this.filedata).then((res) => {
                    this.fullscreenLoading=false;
                    if (res.success) {
                        this.$message({
                            message: '保存成功!',
                            type: 'success'
                        });
                        this.close();
                    }
                    else
                    {
                        this.$message({
                            message: '保存失败!',
                            type: 'warning'
                        });
                    }
                    this.fileList = [];
                });
            } else {
                this.$message({
                    message: '请选择文件!',
                    type: 'warning'
                });
            }
        },
        close()
        {
            this.$emit("closeDialog");
        },
        // 上传文件
        uploadFile(file) {
            this.filedata.append("file", file.file);
        },
        remove(x) {
            this.tableData.splice(x, 1)
        },
        setOptionWidth(event){
            console.log(event);
        // 下拉框弹出时，设置弹框的宽度
        this.$nextTick(() => {
            this.selectOptionWidth = event.srcElement.offsetWidth + "px";
        });
        
        },
        handleRemoteMethodChange(item) {
            var index = this.tableData.findIndex(i => i.Id === item.Id);
            if (index == -1) {
                this.tableData.push(item);
            }
            else {
                this.$message({
                    message: '表格已存在这个考核细项!',
                    type: 'warning'
                });
                return;
            }
        },
        remoteMethod(query) {
            console.log(query);
            if (query !== '') {
                this.loading = true;
                getSelectDetailItem({ key: query }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.options = res.response;
                    } else {
                        this.options = [];
                    }
                })
            }
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePreview(file) {
            console.log(file);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        }
    }
}
</script>

<style lang="less" scoped></style>